import type { ReduxState } from "model/state"
import { DEFAULT_CORE_STATE, type CoreState } from "../core-slice"

export function selectCoreState(state: ReduxState, dashboardId: string): CoreState {
  return state.dashboard.core[dashboardId] ?? DEFAULT_CORE_STATE
}
